import { hDeepCopy } from '@/utils/helpers';
// @vue/component
export default {
  name: 'SortingAndFiltering',

  components: {

  },
  props: {
    allConnections: {
      type: Array,
      default: () => [],
    },
    agentsBelongsToUserList: {
      type: Array,
      default: () => [],
    },
    selectedProject: {
      type: [String, Number],
      default: () => 'all',
    },
  },
  data() {
    return {
      onlyTalkingConnections: false,
      filterByElementId: false,
      filterByAgents: false,
      selectedMenuElements: [],
      selectedAgents: [],
    };
  },

  computed: {
    filteredConnectionList() {
      let filteredList = [];
      if (this.selectedProject === 'all') {
        filteredList = hDeepCopy(this.allConnections);
      } else {
        filteredList = this.allConnections.filter(item => item._project_id === this.selectedProject);
      }
      if (this.filterByElementId) {
        filteredList = filteredList.filter(item => this.currentElementsMenu.includes(item._id_element_menu));
      }
      if (this.filterByAgents) {
        filteredList = filteredList.filter(item => this.agentsBelongsToUserList.some(agent => agent.id === item._agent_id));
      }
      if (this.onlyTalkingConnections) {
        filteredList = filteredList.filter(connection => connection._talking === true);
      }
      if (this.selectedMenuElements.length) {
        filteredList = filteredList.filter(item => this.selectedMenuElements.some(el => el.menu_element === item._menuelement));
      }
      if (this.selectedAgents.length) {
        filteredList = filteredList.filter(item => this.selectedAgents.some(el => el.agent_name === item._agent_name));
      }
      return filteredList;
    },

    filteringCriteriaForMenuElements() {
      const criteria = [];
      this.allConnections.forEach((connection) => {
        const element = {
          project_name: connection._project_name,
          menu_element: connection._menuelement,
        };
        if (connection._id_element_menu && !criteria.some(item => item.menu_element === element.menu_element)
          && (this.selectedProject === 'all' || connection._project_id === this.selectedProject)) {
          criteria.push(element);
        }
      });
      return criteria.sort((a, b) => a.project_name - b.project_name);
    },
    filteringCriteriaForAgents() {
      const criteria = [];
      this.allConnections.forEach((connection) => {
        const element = {
          project_name: connection._project_name,
          agent_name: connection._agent_name,
        };
        if (connection._agent_id && !criteria.some(item => item.agent_name === connection._agent_name)
          && (this.selectedProject === 'all' || connection._project_id === this.selectedProject)
          && this.agentsBelongsToUserList.some(agent => agent.id === connection._agent_id && agent.is_logged)) {
          criteria.push(element);
        }
      });
      return criteria.sort((a, b) => a.project_name - b.project_name);
    },
    currentElementsMenu() {
      return this.$store.getters['dashboard/elementsIds'];
    },
  },

  watch: {
    filteredConnectionList() {
      this.$emit('setFilteredConnectionList', this.filteredConnectionList);
    },
    selectedProject() {
      this.selectedMenuElements = [];
      this.selectedAgents = [];
      // this.filterByAgents = false;
      // this.filterByElementId = false;
      // this.onlyTalkingConnections = false;
    },
  },

  methods: {
    filterConnectionsList(project) {
      this.filteredConnectionsByProject = project === 'all' || !project
        ? this.allConnections
        : this.allConnections.filter(item => item._project_name === project);
    },
    showOnlyTalkingConnections() {
      this.onlyTalkingConnections = !this.onlyTalkingConnections;
      if (this.onlyTalkingConnections) {
        this.filteredConnectionsByProject = hDeepCopy(this.filteredConnectionsByProject).filter(connection => connection._talking === true);
      } else {
        this.filterConnectionsList(this.selectedProject);
      }
    },
  },
};
